module.exports = __webpack_public_path__ + "static/media/07.26312833.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/07.png
// module id = 178
// module chunks = 0